import { QueryParamsEnum } from '@honeycomb/data';
import { QueryParamManager } from '../../utils/QueryParamManager';
import { router } from '../../utils/router';
export function reduceMockErrorAttemptsRouting() {
    var _a, _b;
    const params = new QueryParamManager((_a = router.currentRoute()) !== null && _a !== void 0 ? _a : '/', router.currentParams());
    const currentAttemptsRemaining = (_b = router === null || router === void 0 ? void 0 : router.query()) === null || _b === void 0 ? void 0 : _b[QueryParamsEnum.MOCK_ERROR_RETRY_ATTEMPTS];
    if (currentAttemptsRemaining) {
        try {
            const currentNumberOfAttempts = parseInt(currentAttemptsRemaining);
            if (currentNumberOfAttempts <= 1) {
                params.remove(QueryParamsEnum.MOCK_ERROR_RETRY_ATTEMPTS);
            }
            else {
                params.add(QueryParamsEnum.MOCK_ERROR_RETRY_ATTEMPTS, (currentNumberOfAttempts - 1).toString());
            }
            router.push(router.currentRoute(), () => [params.toString(), undefined, { shallow: true }]);
        }
        catch (err) {
            console.error(err);
        }
    }
}
